import {Component, OnInit} from '@angular/core';
import {SenatorAssignOldName} from '../../../../../api/models/senator-assign-old-name';
import {SenatorQualityGateService} from '../../../../../api/services/senator-quality-gate.service';
import {SenatorQualityGateModel} from '../../../../../api/models/senator-quality-gate-model';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PageEvent} from '@angular/material/paginator';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'app-assign-old-name',
  templateUrl: './assign-old-name.component.html',
  styleUrls: ['./assign-old-name.component.scss'],
  providers: [ConfirmationService]
})
export class AssignOldNameComponent implements OnInit {

  list = [] as SenatorAssignOldName[];
  displayedColumns = ['tradeId', 'botName', 'assignedName', 'sourceUrl', 'transactionDate',
    'oldName', 'processedOn', 'processedBy', 'action'];
  form: FormGroup;
  loading = true;
  processedOnly = false;
  botName = '';
  currentName = '';
  assignedName = '';
  searchByBot = false;
  searchByCurrent = false;
  searchByAssigned = false;
  pageSize = 10;
  private pageNumber = 1;

  constructor(private senatorQualityGateService: SenatorQualityGateService,
              private snackBar: MatSnackBar,
              private confirmationService: ConfirmationService,
              private _formBuilder: FormBuilder) {
    this.form = this._formBuilder.group({
      rows: this._formBuilder.array([])
    });
  }

  get formArray(): FormArray {
    return this.form.get('rows') as FormArray;
  }

  ngOnInit() {
    this.loadTheList();
  }

  saveTheRow(row: SenatorAssignOldName) {
    let message = 'Do you really want to save this entry';
    if (row.oldName != null) {
      message = 'Do you really want to use "' + row.oldName + '" as old name for "' + row.assignedName + '"';
    }
    this.confirmationService.confirm(
      {
        key: 'save',
        message: message,
        accept: () => {
          this.senatorQualityGateService.updateAssignOldNameRow(
            {
              tradeId: row.tradeId,
              oldName: row.oldName
            }
          ).subscribe(
            value => {

            }, error => {

            }, () => {
              this.loadTheList();
            }
          );
        }
      }
    );
  }

  getAlteredName(processedBy?: string) {
    if (processedBy == null) {
      return null;
    }
    if (processedBy.startsWith('muh')) {
      return processedBy.split('.')[1].split('@')[0];
    }
    return processedBy.split('.')[0];
  }

  loadTheList() {
   /* this.loading = true;
    let res = null as SenatorQualityGateModel;
    this.senatorQualityGateService.getReplaceableAssetNames(
      {
        issuerMappingsFilterModel: {
          qualityGateType: 'ASSIGN_OLD_NAME',
          processedType: this.processedOnly == null ? 'ALL' :
            (this.processedOnly == true ? 'PROCESSED' : 'UNPROCESSED'),
          botName: this.botName,
          currentName: this.currentName,
          assignedName: this.assignedName
        },
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      }
    ).subscribe(
      value => {
        res = value;
      },
      error => {
        this.loading = false;
        this.snackBar.open(error.error.message, null, {
          duration: 5000,
          horizontalPosition: 'left',
          verticalPosition: 'bottom'
        });
      }, () => {
        this.loading = false;
        if (res == null) {
          return;
        }
        this.list = res.rowsForAssignOldName;
        this.refreshTheTable();
      }
    );*/
  }

  onPaginateChange(event: PageEvent) {
    if (event == null) {
      return;
    }
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.loadTheList();
  }

  getLabelForTriState(): string {
    return this.processedOnly == null ? 'Showing All' :
      (this.processedOnly == true) ? 'Showing Processed Only' : 'Showing Unprocessed Only';
  }

  private refreshTheTable() {
    this.formArray.reset();
    this.list.forEach(i => {
        this.formArray.push(this._formBuilder.group({
          oldName: i.oldName
        }));
      }
    );
  }
}

